<template lang="pug">
	.campaign-airtime.flex-col.space-medium
		.flex-col
			.font-tiny.grey.upper {{$tCaption('Schedule')}}
			.flex-row.space.align-center
				EditableLabel(ref="airtimeSchedule", :editing="!product.AirtimeScheduleFile", :disabled="info.readonly")
					span {{fileName}}
					template(slot="editor")
						FileUploader(
							:text="$tCaption('Upload schedule (.xml)')",
							:multiple="false",
							:accept="['.xml']",
							@upload="fileChanged"
					)
				fas.button-tiny(v-if="product.AirtimeScheduleFile && product.AirtimeScheduleFile.Url", icon="download", @click="$Data.downloadURI(product.AirtimeScheduleFile.Url)", size="xs")
		.flex-row.space-large
			.flex-col
				.font-tiny.grey.upper {{$tCaption('Costs')}}
				span {{$formatNumber(product.AirtimeCost || 0)}}
			.flex-col
				.font-tiny.grey.upper {{$tCaption('Spots')}}
				span {{$formatNumber(product.AirtimeSpots || 0, 0)}}
		.flex-col
			.font-tiny.grey.upper {{$tCaption('Stations')}}
			.flex-row
				CampaignStations(ref="stations", :info="info")
</template>

<script>
	import _ from 'lodash';
	import DxButton from 'devextreme-vue/button';
	import DxTextBox from 'devextreme-vue/text-box';	
	import Loader from 'app-core/Loader.vue';	
	import FileUploader from 'app-core/FileUploader.vue';
	import EditableLabel from 'app-core/EditableLabel.vue';
	import CampaignStations from './CampaignStations.vue';

	export default {
		translationCategory: 'campaign.Detail',
		name: 'campaign-airtime',
		components: {
			DxButton, DxTextBox, Loader, FileUploader, EditableLabel, CampaignStations
		},
		props: ['info', 'active', 'product'],
		data() {
			return {
				radios: []
			};
		},
		computed: {
			campaign() {
				return this.info?.campaign;
			},
			campaignProducts() {
				return this.info?.campaignProducts;
			},
			totals() {
				return this.radios.reduce((total, f) => ({ spots: total.spots + f.spots, cost: total.cost + f.cost }), { spots: 0, cost: 0 });
			},
			fileName() {
				let split = this.product.AirtimeScheduleFile?.Url?.split('-');
				return split?.length && split[split.length-1] || this.$tCaption('Airtime schedule.xml');
			}
		},
		watch: {
			product() {
			}
		},
		mounted() {
			if (__DEBUG__)
				window.campaignAirtime = this;
		},
		methods: {
			fileChanged(files) {
				if (files?.length) {
					var reader = new FileReader();
					reader.onload = () => {
						if (this.processScheduleFile(reader.result)) {
							var reader2 = new FileReader();
							reader2.onload = () => {
								const content = reader2.result.split(';base64,')[1];				
								this.product.AirtimeScheduleFile = {
									Data: {
										Base64Content: content,
										FileName: files[0].name
									}
								}
								this.$refs.airtimeSchedule.release();
							};
							reader2.readAsDataURL(files[0]);
						}
					};
					reader.readAsText(files[0]);
				}
			},
			processScheduleFile(data) {
				let xmlDoc = null;
				if (window.DOMParser)
				{
					let parser = new window.DOMParser();
					xmlDoc = parser.parseFromString(data, 'text/xml');
				}
				else // Internet Explorer
				{
					xmlDoc = new window.ActiveXObject('Microsoft.XMLDOM');
					xmlDoc.async = false;
					xmlDoc.loadXML(data);
				}

				const xmlJson = this.$Data.xmlToJson(xmlDoc);
				this.radios = [];

				const orders = Array.isArray(xmlJson.Transmission.Transaction.Campaign.Order) ? xmlJson.Transmission.Transaction.Campaign.Order : [xmlJson.Transmission.Transaction.Campaign.Order];
				const stations = {};
				orders.map(order => {
					const stationOrders = Array.isArray(order.StationOrder) ? order.StationOrder : [order.StationOrder];
					stationOrders.map(stationOrder => {
						const station = stationOrder.Station;
						const spotQuantity = _.sumBy(stationOrder.BuyLine, bl => _.sumBy(bl.AirPeriod, (v) => parseFloat(v.SpotQuantity) || 0) || 0);
						const budget = _.sumBy(stationOrder.BuyLine, bl => _.sumBy(bl.AirPeriod, (v) => parseFloat(v.SpotQuantity) * parseFloat(v.UnitRate) || 0) || 0);
						const stationName = `${station.StationName} ${station.Band}`;
						stations[stationName] = true;

						let existsRadio = _.find(this.radios, (r) => r.oid === stationName);
						if (!existsRadio) {
							this.radios.push({ oid: stationName, name: stationName, logo: null, spots: spotQuantity, cost: budget });
						} else {
							existsRadio.spots = (existsRadio.spots || 0) + (spotQuantity || 0);
							existsRadio.cost = (existsRadio.cost || 0) + (budget || 0);
						}

						if (__DEBUG__)
							console.debug('ExRad', { existsRadio });
					});
				});

				if (__DEBUG__)
					console.debug('processScheduleFile', { orders, radios: this.radios });

				if (this.totals.cost) {
					this.product.AirtimeCost = this.totals.cost;
					this.product.AirtimeSpots = this.totals.spots;
					this.campaign.__recalcBudget();
					this.$refs.stations.addStationsByNames(Object.keys(stations));
					return true;
				}

				return false;
			}
		}
	};
</script>
<style lang='scss'>
	@import "main/themes/generated/variables.base.scss";
	.campaign-airtime {
		.button-tiny {
			padding: 4px;
			border-radius: 4px;
			background: rgba(255,255,255,0.6);
			cursor: pointer;
			transition: 0.3s;

			&:hover {
				background: rgba(255,255,255,1);
			}

		}
	}
</style>
 